import _get from 'lodash/get';

export const columns = ({ t }) => [
  {
    title: t('Name'),
    name: 'name'
  },
  {
    title: t('Address'),
    name: 'address'
  },
  {
    title: t('City'),
    name: 'city'
  },
  {
    title: t('State/Province'),
    name: 'state'
  },
  {
    title: t('ZIP/Postal Code'),
    name: 'postalCode'
  },
  {
    title: t('Country'),
    name: 'country'
  },
  {
    title: t('Status'),
    name: 'status'
  }
];

export const formatData = (locations, t) =>
  locations.map(location => ({
    id: location.id,
    name: location.name,
    address: _get(location, 'address.address1', ''),
    city: _get(location, 'address.city', ''),
    state: _get(location, 'address.state', ''),
    postalCode: _get(location, 'address.postalCode', ''),
    country: _get(location, 'address.country', ''),
    status: location.active ? t('Active') : t('Inactive')
  }));

export default {
  columns,
  formatData
};
